import { UploadcareFile } from './file';

export enum BackgroundRemovalType {
  Disabled = 'DISABLED',
  CoverRequired = 'COVER_REQUIRED',
  AllOptional = 'ALL_OPTIONAL',
  CoverRequiredOthersOptional = 'COVER_REQUIRED_OTHERS_OPTIONAL',
  Default = 'DEFAULT',
}

export interface OriginalAndBackgroundRemovedImage {
  backgroundRemovedImage?: UploadcareFile;
  originalImage?: UploadcareFile;
}
